import React from 'react';
import { List, ListItem, ListItemText, ListItemIcon } from '@material-ui/core';
import { ChevronRight as ChevronRightIcon, ChevronLeft as ChevronLeftIcon, } from '@material-ui/icons';
export var CategoryList = function (_a) {
    var path = _a.path, categories = _a.categories, onNextClick = _a.onNextClick, onSelect = _a.onSelect;
    return (React.createElement(List, { component: "div", disablePadding: true },
        path.length > 0 ? (React.createElement(ListItem, { divider: true, button: true, onClick: function () { return onNextClick(''); } },
            React.createElement(ListItemIcon, null,
                React.createElement(ChevronLeftIcon, { color: "secondary" })),
            React.createElement(ListItemText, { primary: "TOP\u30E1\u30CB\u30E5\u30FC\u306B\u623B\u308B" }))) : (React.createElement(ListItem, { divider: true, button: true, onClick: function () { return onSelect(null); } },
            React.createElement(ListItemText, { primary: "\u5168\u3066\u306E\u30AB\u30C6\u30B4\u30EA\u30FC" }))),
        categories.map(function (c) {
            var _a;
            return (React.createElement(ListItem, { divider: true, button: true, component: "div", key: "".concat(c.id), onClick: function () {
                    if (!c.sub || !c.sub.length) {
                        return onSelect(c);
                    }
                    onNextClick("".concat(c.id));
                } },
                React.createElement(ListItemText, { primary: c.title }),
                ((_a = c.sub) === null || _a === void 0 ? void 0 : _a.length) ? React.createElement(ChevronRightIcon, { color: "secondary" }) : null));
        })));
};
//# sourceMappingURL=CategoryList.js.map